import { createFileRoute } from '@tanstack/react-router'
import { FaqPage } from '@/features/faq/FaqPage'

export const Route = createFileRoute('/_authenticated/faq')({
  component: FaqPage,
})
